import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { IPreNoticeList, IPreNoticeListResponse } from '../_types'
import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

export const fetchPreNoticeList = async () => {
  const res = await axios.get<IPreNoticeListResponse>(
    `${process.env.NEXT_PUBLIC_API_ENDPOINT}/course/v1/early-booking-items?sort=order:asc`,
  )
  return convertCaseList(res.data, ConvertType.CAMEL)
}

export const usePreNoticeListQuery = () => {
  return useQuery<IPreNoticeList[]>({
    queryKey: ['preNoticieList'],
    queryFn: fetchPreNoticeList,
  })
}
